import { render, staticRenderFns } from "./PolicyQuickActions.vue?vue&type=template&id=e4aa5d1c"
import script from "./PolicyQuickActions.vue?vue&type=script&lang=js"
export * from "./PolicyQuickActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports